<template>
  <div
    class="fixed left-0 top-60px sm:top-80px w-full bg-white shadow-lg border-t border-gray-100 z-50 animate-fade-in-down"
  >
    <div class="landing-container py-40px flex">
      <!-- Left Sidebar -->
      <div class="w-240px border-r border-gray-100 pr-40px shrink-0">
        <div class="text-18px font-600 mb-20px text-#1e293b">解决方案分类</div>
        <div class="flex flex-col gap-4px" role="tablist" aria-label="解决方案分类">
          <div
            v-for="(tab, index) in abilityTabs"
            :id="`solution-tab-${index}`"
            :key="index"
            class="px-16px py-12px rounded-8px cursor-pointer text-14px transition-colors focus-visible:outline-primary"
            :class="
              activeCategory === index ? 'bg-#ECEFF6 text-primary pf-sc-semibold' : 'text-main/70'
            "
            role="tab"
            :aria-selected="activeCategory === index"
            :aria-controls="`solution-panel-${index}`"
            tabindex="0"
            @mouseenter="activeCategory = index"
            @keydown.enter="activeCategory = index"
            @keydown.space.prevent="activeCategory = index"
          >
            {{ tab.title }}
          </div>
        </div>
      </div>

      <!-- Right Content -->
      <div class="flex-1 pl-60px">
        <div
          :id="`solution-panel-${activeCategory}`"
          class="grid grid-cols-2 gap-x-60px gap-y-40px"
          role="tabpanel"
          :aria-labelledby="`solution-tab-${activeCategory}`"
        >
          <NuxtLink
            v-for="(item, idx) in currentItems"
            :key="idx"
            class="flex gap-16px group/item cursor-pointer"
            :to="`/solutions/${item.id}`"
            @click="$emit('close')"
          >
            <!-- Icon -->
            <i :class="[item.icon, 'wh-48px']" aria-hidden="true"></i>

            <!-- Text -->
            <div>
              <div
                class="text-16px font-600 text-#1e293b mb-8px group-hover/item:text-#2563eb transition-colors"
              >
                {{ item.title }}
              </div>
              <div class="text-12px text-#64748b lh-20px line-clamp-2">{{ item.desc }}</div>
            </div>
          </NuxtLink>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { abilities, abilityTabs } from '~/constants/common'

  defineEmits(['close'])

  const activeCategory = ref(0)

  const currentItems = computed(() => {
    const activeTabId = abilityTabs[activeCategory.value]?.id
    return activeTabId ? abilities[activeTabId] : []
  })
</script>

<style scoped lang="scss">
  @keyframes fadeInDown {
    from {
      opacity: 0;
      transform: translateY(-10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  .animate-fade-in-down {
    animation: fadeInDown 0.2s ease-out forwards;
    &::before {
      content: '';
      @apply absolute -top-10px left-0 w-full h-10px;
    }
  }
</style>
